import { createSlice } from '@reduxjs/toolkit';
import { libraryStates } from '../../utils/libraryStates';

const initialState = {
	topics: [],
	databases: [],
	institutionCode: '',
	institutionLogo: '',
	isMedicalInstitution: false,
	requestLogin: false,
	uniqueLogin: false,
	assignedLogin: [],
	googleAuthConfig: null,
	ebooksAccess: false,
	languageInstitution: 'en',
	isActive: true,
	institutionState: libraryStates.DELIVERED,
};

const institutionSlice = createSlice({
	name: 'institution',
	initialState,
	reducers: {
		setTopics: (state, action) => {
			state.topics = action.payload;
		},
		setDatabases: (state, action) => {
			state.databases = action.payload;
		},
		setInstitutionCode: (state, action) => {
			state.institutionCode = action.payload;
		},
		setInstitutionLogo: (state, action) => {
			state.institutionLogo = action.payload;
		},
		setIsMedicalInstitution: (state, action) => {
			state.isMedicalInstitution = action.payload;
		},
		setRequestLogin: (state, action) => {
			state.requestLogin = action.payload;
		},
		setUniqueLogin: (state, action) => {
			state.uniqueLogin = action.payload;
		},
		setAssignedLogin: (state, action) => {
			state.assignedLogin = action.payload;
		},
		setGoogleAuthConfig: (state, action) => {
			state.googleAuthConfig = action.payload;
		},
		setEbooksAccess: (state, action) => {
			state.ebooksAccess = action.payload;
		},
		setLanguageInstitution: (state, action) => {
			state.languageInstitution = action.payload;
		},
		setIsActive: (state, action) => {
			state.isActive = action.payload;
		},
		setInstitutionState: (state, action) => {
			state.institutionState = action.payload;
		},
	},
});

export const {
	setTopics,
	setDatabases,
	setInstitutionCode,
	setInstitutionLogo,
	setIsMedicalInstitution,
	setRequestLogin,
	setUniqueLogin,
	setAssignedLogin,
	setGoogleAuthConfig,
	setEbooksAccess,
	setLanguageInstitution,
	setIsActive,
	setInstitutionState,
} = institutionSlice.actions;

export default institutionSlice.reducer;
